import $9vaWN$macrostrathyper from "@macrostrat/hyper";
import $9vaWN$classnames from "classnames";
import {Component as $9vaWN$Component} from "react";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $9db2f56868441fdb$exports = {};

$parcel$export($9db2f56868441fdb$exports, "PickerControl", () => $9db2f56868441fdb$export$e587c41f8a2e48c5);
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */ 


class $9db2f56868441fdb$export$e587c41f8a2e48c5 extends (0, $9vaWN$Component) {
    constructor(props){
        super(props);
        this.onUpdate = this.onUpdate.bind(this);
    }
    static #_ = this.defaultProps = {
        states: [
            {
                label: "State 1",
                value: "state1"
            },
            {
                label: "State 2",
                value: "state2"
            }
        ],
        vertical: true,
        isNullable: false
    };
    render() {
        const { states: states, activeState: activeState, vertical: vertical } = this.props;
        let className = (0, $9vaWN$classnames)("bp5-button-group", "bp5-fill", {
            "bp5-vertical": vertical,
            "bp5-align-left": vertical
        });
        return (0, $9vaWN$macrostrathyper)("div.picker-control", [
            (0, $9vaWN$macrostrathyper)("div", {
                className: className
            }, states.map((d)=>{
                className = (0, $9vaWN$classnames)("bp5-button", {
                    "bp5-active": this.props.activeState === d.value
                });
                return (0, $9vaWN$macrostrathyper)("button", {
                    type: "button",
                    className: className,
                    onClick: this.onUpdate(d.value)
                }, d.label);
            }))
        ]);
    }
    onUpdate(value) {
        return ()=>{
            if (value === this.props.activeState) {
                if (!this.props.isNullable) return;
                value = null;
            }
            if (this.props.onUpdate == null) return;
            return this.props.onUpdate(value);
        };
    }
}


export {$9db2f56868441fdb$export$e587c41f8a2e48c5 as PickerControl};
//# sourceMappingURL=column-components.f332569f.js.map
